import { STORE_ID } from '@/constants/stores';
import { OtherLanguageByCountry, OtherStoreModel, StoreConfModel } from '@/models';

export const getCodeISO = (storeConf: StoreConfModel, storeIdForPrice: string) => {
	let codeISO = storeConf.codeISO;

	if (storeConf.storeId === STORE_ID.COM && storeIdForPrice === STORE_ID.COM) {
		return 'WW';
	}

	if (storeIdForPrice) {
		const store = storeConf?.otherStores.find((s) => s.storeId === storeIdForPrice);
		codeISO = store ? store.codeISO : storeConf.codeISO;
	}
	return codeISO;
};

export const getCountryName = (country: OtherStoreModel | OtherLanguageByCountry, t: (key: string) => string) => {
	return [STORE_ID.SCHWEIZ, STORE_ID.SUISSE].includes(country.storeId)
		? t(`countries:${country.codeISO}`)
		: t(`stores.${country.storeId}`);
};
